import AjaxClass from './Validation/ajaxClass';
import FormValidate from './Validation/formValidateClass';
import MessageHandler from './Validation/messageHandler';

export default function forms() {
    //form precisa ter id também
    $('[form]').on('submit', function (e) {
        e.preventDefault();
        const Loader = document.getElementById("loading-forms")

        let form = $(this);
        let fields = form.serializeArray();
        let validation = new FormValidate(fields, 1, form.attr('id'));

        let images = '';
        if ($(this).find('input[type=file]').length > 0) {
            images = $(this).find('input[type=file]');
            Array.from(images).forEach((e) => {
                let image = {'name': $(e).attr('name'), 'value': $(e)[0].files[0]}
                fields.push(image);
            })
        }

        let selects = $(`#${form.attr('id')} select`).get();
        selects.forEach((element) => {
            if (!$(element).attr('disabled')) {
                let select = {
                    name: $(element).attr('name'),
                    value: $(element).val() ? $(element).val() : '',
                };
                fields.splice(fields.length - 1, 0, select);
            }
        })

        validation.validateAll(fields);
        let error = validation.hasError();
        
        MessageHandler.removeAllFormFailMessages()

        if (error) {
            let errorMessageId = validation.getErrorId();
            console.log(errorMessageId);
            MessageHandler.showFailMessage(form.attr('id'), errorMessageId, false);
            return false;
        }

        let password = form.find('[name=password]');
        let passwordConfirmation = form.find('[name=password_confirmation]');
        if (password.val() && passwordConfirmation.val() && password.val() !== passwordConfirmation.val()) {
            MessageHandler.showFailMessage(form.attr('id'), "password_confirmation", false);
            return false;
        }

        let terms = $("#" + form.attr('id')).find("input[type='checkbox']");
        if (terms.length > 0) {
            let termsChecked = terms.prop('checked') == true;
            if (!error && !termsChecked){
                error = true
                const id = terms.attr('id');
                MessageHandler.showFailMessage(form.attr('id'), id, false);
                return false;
            } else {
                let radio = {
                    name: $(element).attr('name'),
                    value: $(element).val() ? $(element).val() : '',
                };
                fields.splice(fields.length - 1, 0, radio);
            }
        }

        let radio = $("#" + form.attr('id')).find("input[type='radio']");
        if (radio.length > 0) {
            let radioChecked = $('input[type=radio]:checked').length > 0;
            console.log(radioChecked);
            
            if (!error && !radioChecked){
                error = true
                const name = radio.attr('name');
                MessageHandler.showFailMessage(form.attr('id'), name, false);
                return false;
            }
        }

        if (error == false) {
            Loader.classList.add("open-modal");
            if ($(this).attr('disabled') == 'disabled') {
                return false;
            }
            let formData = form.serialize();
            if (images.length > 0) {
                formData = new FormData();
                fields.forEach(obj => {
                    if (!obj.value) {
                        obj.value = '';
                    }
                    formData.append(obj.name, obj.value);
                });
            }
            $(this).attr('disabled', 'disabled');
            let type = 'POST';
            let url = $(this).attr('action');
            let dataType = 'json';
            const modalSuccess = document.getElementById('success-message-forms');
            const modalSuccessDescription = document.querySelector('#success-message-forms .description');
            const modalError = document.getElementById('error-message-forms');
            const modalDescription = document.querySelector('#error-message-forms .description');
            class Contact extends AjaxClass {
                successFunction(data, form) {
                    Loader.classList.remove("open-modal");
                    if (data.status == true) {
                        $(form).trigger("reset");
                        $(form).removeAttr('disabled');
                        if (data.redirect) {
                            window.location = data.redirect;
                        } else if (data.register) {
                            $("#sucess-content").removeClass('d-none');
                            $("#registerForm").addClass('d-none');
                        } else if (data.forgotPass) {
                            $("#sucess-content").removeClass('d-none');
                            $("#forgot-password-form").addClass('d-none');
                        } else if (data.passwordChecked) {
                            $(".changePassword").addClass('d-none');
                            $(".changePasswordNew").removeClass('d-none');
                        } else if (data.contact) {
                            $("#contactForm").addClass('d-none');
                            $("#sucess-content").removeClass('d-none');
                        } else if (data.passwordUpdated) {
                            $(".changePasswordNew").addClass('d-none');
                            $(".changePasswordSucess").removeClass('d-none');
                        } else {
                            modalSuccess.classList.add("open-modal");
                            modalSuccessDescription.innerHTML = data.txt
                        }
                    } else {
                        let message = $("#" + form.attr('id')).find('.error-message');
                        message.addClass('d-flex');
                        message.text(data.txt);
                        setTimeout(function() {
                            message.fadeOut('slow');
                            message.removeClass('d-flex');
                         }, 2000);
                        $(form).removeAttr('disabled');
                    }
                };
                errorFunction(xhr, textStatus, errorThrown) {
                    Loader.classList.remove("open-modal");
                    let message = $("#" + form.attr('id')).find('.error-message');
                    message.addClass('d-flex');
                    let txt = "Ocorreu um erro. Tente novamente mais tarde.";
                    // modalDescription.innerHTML = "Ocorreu um erro. Tente novamente mais tarde.";
                    
                    if (errorThrown == 'Too Many Requests' || xhr.responseText == 'Too Many Requests') {
                        txt = "Muitas tentativas! Aguarde um minuto antes de tentar novamente.";
                    }
                    // modalError.classList.add("open-modal");

                    message.text(txt);
                    setTimeout(function() {
                        message.fadeOut('slow');
                        message.removeClass('d-flex');
                     }, 2000);
                    $(form).removeAttr('disabled');
                };
            }
            let ajax = new Contact(form, type, url, dataType, formData);
            ajax.send();
        }

        return false;
    });

    $('[phone]').on('keypress', function (event) {
    // Get the character code of the key pressed
    const charCode = (event.which) ? event.which : event.keyCode;

    // Allow: backspace, delete, tab, escape, enter, home, end, left, right, and period
    if (charCode === 8 || charCode === 46 || charCode === 9 || charCode === 27 ||
        charCode === 13 || charCode === 35 || charCode === 36 || charCode === 37 ||
        charCode === 39 || (charCode === 190 && !this.value.includes('.'))) {
        return;
    }

    // Ensure that it is a number and stop the keypress
    if (charCode < 48 || charCode > 57) {
        event.preventDefault();
    }
    });

    $('[phone]').on('blur', function (e) {
        mascaraDeTelefone(this);
    });

    $('[phone]').on('focus', function (e) {
        tiraHifen(this);
    });

    $('[document]').on('blur', function (e) {
        mascaraDeDocumento(this);
    });

    $('[document]').on('focus', function (e) {
        tiraHifen(this);
    });

    function mascaraDeDocumento(documento){
        const textoAtual = documento.value.replace(/[^0-9]/g, '');

        let textoAjustado;
        const parte1 = textoAtual.slice(0,3);
        const parte2 = textoAtual.slice(3,6);
        const parte3 = textoAtual.slice(6,9);
        const parte4 = textoAtual.slice(9,11);
        if (parte1)  textoAjustado = `${parte1}`
        if (parte1 && parte2) textoAjustado = `${parte1}.${parte2}`
        if (parte1 && parte2 && parte3) textoAjustado = `${parte1}.${parte2}.${parte3}`
        if (parte1 && parte2 && parte3 && parte4) textoAjustado = `${parte1}.${parte2}.${parte3}-${parte4}`

        if (!textoAjustado) {
            documento.value = null;
        } else {
            documento.value = textoAjustado;
        }
    }
    function mascaraDeTelefone(telefone){
        const textoAtual = telefone.value.replace(/[^0-9]/g, '');
        const isCelular = textoAtual.length >= 11;
        let textoAjustado;
        if(isCelular) {
            const parte1 = textoAtual.slice(0,2);
            const parte2 = textoAtual.slice(2,4);
            const parte3 = textoAtual.slice(4,9);
            const parte4 = textoAtual.slice(9,13);
            if (parte1)  textoAjustado = `+${parte1}`
            if (parte1 && parte2) textoAjustado = `+${parte1} (${parte2})`
            if (parte1 && parte2 && parte3) textoAjustado = `+${parte1} (${parte2}) ${parte3}`
            if (parte1 && parte2 && parte3 && parte4) textoAjustado = `+${parte1} (${parte2}) ${parte3}.${parte4}`
        } else {
            const parte1 = textoAtual.slice(0,2);
            const parte2 = textoAtual.slice(2,4);
            const parte3 = textoAtual.slice(4,8);
            const parte4 = textoAtual.slice(8,12);
            if (parte1)  textoAjustado = `+${parte1}`
            if (parte1 && parte2) textoAjustado = `+${parte1} (${parte2})`
            if (parte1 && parte2 && parte3) textoAjustado = `+${parte1} (${parte2}) ${parte3}`
            if (parte1 && parte2 && parte3 && parte4) textoAjustado = `+${parte1} (${parte2}) ${parte3}.${parte4}`
        }

        if (!textoAjustado) {
            telefone.value = null;
        } else {
            telefone.value = textoAjustado;
        }
    }
    function tiraHifen(telefone) {
        const textoAtual = telefone.value;
        const textoAjustado = textoAtual.replace(/\W/g, '');
    
        telefone.value = textoAjustado;
    }
}